"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _immutable = require("immutable");

var _fluxActions = require("flux-actions");

var _mergeWithCollectionOfType = _interopRequireDefault(require("settings-ui-lib/utils/mergeWithCollectionOfType"));

var _Team = _interopRequireDefault(require("../records/Team"));

var _PayloadActions = require("../actions/PayloadActions");

var initialState = (0, _immutable.Map)();

var _default = (0, _fluxActions.handleActions)((0, _defineProperty2.default)({}, _PayloadActions.FetchPayloadActionTypes.SUCCESS, function (state, action) {
  return (0, _mergeWithCollectionOfType.default)(_Team.default, action.payload.data.teams, state);
}), initialState);

exports.default = _default;
module.exports = exports.default;